// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7ca10618","977":"e450a4fc"}[chunkId] + ".chunk.js";
};